module.exports = __webpack_public_path__ + "static/gulls-zoom-ccaaaa3936d4c578629a21da255d3dfc.jpg";